/**
 * Coming-soon page configuration.
 *
 * launchDate: set this to your confirmed launch moment as an ISO string,
 *   e.g. "2027-02-01T08:00:00+02:00". While it is null, the countdown runs
 *   against a temporary 30-day preview target so the timer can be reviewed.
 *
 * notifyEndpoint: public URL of the form backend that stores sign-ups,
 *   e.g. "https://formspree.io/f/abcdwxyz". Set the form's notification
 *   recipient to info@liftoffinvestments.co.bw in the backend's dashboard.
 *   This URL is not a secret — never put passwords, SMTP or API keys here.
 *   While it is null, the form validates addresses but tells visitors
 *   notifications are not available yet — nothing is saved.
 */
export const siteConfig: {
  launchDate: string | null;
  notifyEndpoint: string | null;
} = {
  launchDate: null,
  notifyEndpoint: "https://formspree.io/f/xljgvvvb",
};
